import Vue from 'vue';

// When the request succeeds
const success = (data, context) => {
  if (data.status === 'success') {
    context.payments = data.payments.data;
    context.paymentsCurrentPage = data.payments.current_page;
    context.paymentsPageCount = data.payments.last_page;
    let arr = [];
    const start = (Math.floor((context.paymentsCurrentPage / 10) - 0.01) * 10) +1;
    for (let i = start; i <= (start + 9) && i <= context.paymentsPageCount; i++) {
      arr.push(i);
    }
    context.totalPageCountsArr = arr;
  } else {
    context.payments = [];
  }
};

// When the request fails
const failed = (context, error) => {
  context.showToasterError(error);
};

export default context => Vue.$http.get(`payments?page=${context.paymentsCurrentPage}&filterByStatus=${context.filterByStatus}&searchText=${context.searchText}`)
      .then((response) => {
        if (response.status === 200) {
          success(response.data, context);
        }
      })
      .catch((error) => {
        failed(context, error);
      });



// WEBPACK FOOTER //
// ./src/app/services/payment/get.js